// Per-vertical presets — the noun set (wording) + attribute-tag vocabulary shown to diners. The
// venue's `vertical` (from the API) selects which preset to use. Mirrored in the owner app's
// constants/verticals.js; the backend (_helpers/verticals.js) only validates the tag keys.
const VERTICALS = {
    restaurant: {
        label: 'Restaurant',
        nouns: {
            menu: 'Menu', item: 'Dish', items: 'dishes', category: 'Category',
            search: 'Search the menu…', browse: 'What can we serve you today?',
            emptyMenu: 'Menu coming soon', emptyCategory: 'No items in this category yet.',
        },
        tags: [
            { key: 'veg', label: 'Vegetarian', icon: '🌱', short: 'Veg' },
            { key: 'vegan', label: 'Vegan', icon: '🌿', short: 'Vegan' },
            { key: 'gf', label: 'Gluten-free', icon: '🌾', short: 'GF' },
            { key: 'spicy', label: 'Spicy', icon: '🌶️', short: 'Spicy' },
        ],
    },
    retail: {
        label: 'Retail / Shop',
        nouns: {
            menu: 'Catalog', item: 'Product', items: 'products', category: 'Category',
            search: 'Search products…', browse: 'What are you looking for?',
            emptyMenu: 'Catalog coming soon', emptyCategory: 'No products in this category yet.',
        },
        tags: [
            { key: 'new', label: 'New', icon: '✨', short: 'New' },
            { key: 'sale', label: 'On sale', icon: '🏷️', short: 'Sale' },
            { key: 'instock', label: 'In stock', icon: '✅', short: 'In stock' },
            { key: 'eco', label: 'Eco', icon: '♻️', short: 'Eco' },
        ],
    },
    services: {
        label: 'Services',
        nouns: {
            menu: 'Services', item: 'Service', items: 'services', category: 'Category',
            search: 'Search services…', browse: 'How can we help you today?',
            emptyMenu: 'Services coming soon', emptyCategory: 'No services in this category yet.',
        },
        tags: [
            { key: 'popular', label: 'Popular', icon: '⭐', short: 'Popular' },
            { key: 'new', label: 'New', icon: '✨', short: 'New' },
            { key: 'unisex', label: 'Unisex', icon: '👤', short: 'Unisex' },
            { key: 'quick', label: 'Quick', icon: '⚡', short: 'Quick' },
        ],
    },
};

// Resolve a venue's vertical key to its preset, defaulting to restaurant for unknown/missing values.
export const getVertical = (key) => VERTICALS[key] || VERTICALS.restaurant;

export default VERTICALS;
